/*
Poornima 09/19/2022 2700912712 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
saikrishna 10/04/2022 2700912712 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
Suresh Peddavoora 10/28/2022 2700912712  Added Class Name for Table Enhancements
Akhila 11/01/2022 2700912712 TablePagination bugFix
Lalitha 11/10/2022 2700912712 Added title Created by in table and arrange table
Ashraf 11/15/2022 2700912712 disabling save button based on role access

*/

import React, {createRef, useContext, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import DialogBox from '../../../../../components/DialogBox';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {systemNotesResetToast, systempostNotesFilterInformation} from '../../../../../redux/reducers/BRE/SystemNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
export default function SystemNotes({setBreCode, breCode}) {
  const {systemnotesStatus, systemisLoading,
    systemerrorMsg} = useSelector(({systemNotes}) => systemNotes);
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'BRE Code',
      field: 'code',
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created by',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  let transcription = '';
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {roleData} = useSelector(({role}) => role);
  const AddRoleAccess = !roleData?.window?.['Business Rule Engine']?.['BR']?.add;
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };

  useEffect(() => {
    if (systemnotesStatus === 200 || systemerrorMsg) {
      handleDialogClose();
      tableRef.current.onQueryChange();
      setTimeout(() => {
        dispatch(systemNotesResetToast());
      }, 2000);
    }
  }, [systemnotesStatus, systemerrorMsg]);
  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        systempostNotesFilterInformation({
          code: breCode ? breCode : ' ',
          noteText: data,
        }),
      );
    }
  };

  return (
    <div className="custom-table drag-and-drop-table global-field-table">
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        hideFooter={true}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            isLoading={systemisLoading}
            charLimitMsg={charLimitMsg}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>
      <GuiTable
        title=""
        columns={columns}
        icons={tableIcons}
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve) => {
            const url = `rules/find/all/filternotes`;
            const bodyObj = {
              code: breCode ? breCode : ' ',
              description: '',
              limit: query.pageSize ? query.pageSize : null,
              page:
                arrayLast && query.page >= 1 ?
                  query.page :
                  arrayLast ?
                    (query.page <= 1 && query.page + 1) || query.page - 1 :
                    query.page + 1,
              orderBy: '',
              orderDirection: '',
              search: '',
            };
            if (!breCode) {
              resolve({
                data: [],
                page: 0,
                totalCount: 5,
              });
            } else {
              httpPaginationPost(url, bodyObj).then((response) => {
                if (response?.status === 200) {
                  const data = response.data.response.resultObjects;

                  resolve({
                    data: data.length > 0 ? data : [],
                    page: response.data.response.page - 1,
                    totalCount: response.data.response.count,
                  });
                  setArrayLast(response.data.response.resultObjects.length === 1);
                } else {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                }
              })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            }
          })
        }
        options={{
          search: false,
          toolbar: true,
          pageSize: rows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
        actions={[
          {
            icon: () => (
              <div>
                <Button variant="outlined" className={`search-btn ${classes.buttonRoot}`} disabled={AddRoleAccess}>
                  <AddIcon /> Add
                </Button>
              </div>
            ),
            disabled: AddRoleAccess,
            isFreeAction: true,
            onClick: () => handleSelectedNotesOption(),
          },
        ]}
        components={{
          Pagination: (props) => (
            <div className="global-field-table-footer ">
              <div className="mt-2">

              </div>
              <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={[15, 20, 25]}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            </div>
          ),
        }}
      />
    </div>
  );
}
